import React, { useEffect } from "react";
import {
  Form,
  Button,
  Input,
  message,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  getBussinesCradSerial,
  getCard,
  updateGCard,
} from "../store/actions/gcardAction";
const EditGcardForm = ({ translate, cardId }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  useEffect(() => {
    dispatch(getCard(cardId))
      .unwrap()
      .then((res) => {
        form.setFieldsValue({
          ...res,
          createdDate: res.createdDate
            ? dayjs(res.createdDate)
            : null,
        });
      })
      .catch((err) => {
        message.error(String(err), 4);
      });
  }, [dispatch, form, cardId]);

  const onFinish = (values) => {
    values.createdDate = dayjs(values.createdDate).format("YYYY-MM-DD");
    const payload = {
      values,
      id: cardId,
    };
    dispatch(updateGCard(payload))
      .unwrap()
      .then((res) => {
        message.success("Card Is Successfuly updated");
        form.resetFields();
      })
      .catch((err) => {
        message.error(err, 3);
      });
  };
  return (
    <div className="google_card_form">
      <Form
        form={form}
        name="googlecard"
        initialValues={{
          branch: "",
          serial: "",
          company: "",
          phone: "",
          map_url: "",
          nfc_url: "",
          employee: "",
          count1: 1,
          price:0,
          paymentType:"cash",
          createdDate: dayjs(),
        }}
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <div className="row">
          {/* branch */}
          <div className="col-sm-12 col-md-6">
            <Form.Item
              label={translate("FORM.BRANCH")}
              name="branch"
              rules={[{ required: true, message: "Please input your branch!" }]}
            >
              <Select
                showSearch
                style={{ height: 40 }}
                placeholder="Select a branch"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => {
                  dispatch(getBussinesCradSerial(value))
                    .unwrap()
                    .then((res) => {
                      form.setFieldValue("serial", res);
                    })
                    .catch((err) => {
                      message.error(String(err), 4);
                    });
                }}
              >
                <Select.Option value="infoTech"> InfoTech </Select.Option>
                <Select.Option value="toplevel"> Top Level </Select.Option>
              </Select>
            </Form.Item>
          </div>
            {/* serial  */}
          <div className="col-sm-12 col-md-6">
            <Form.Item
              label={translate("FORM.SERIAL")}
              name="serial"
              rules={[{ required: true, message: "Please input serial!" }]}
            >
              <Input style={{ height: 40 }} disabled />
            </Form.Item>
          </div>
          {/* company name  */}
          <div className="col-sm-12 col-md-8">
            <Form.Item
              label={translate("FORM.COMPANY")}
              name="company"
              rules={[
                {
                  required: true,
                  message: "Please input your company name!",
                },
              ]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* phone  */}
          <div className="col-sm-12 col-md-4">
            <Form.Item
              label={translate("FORM.PHONE")}
              name="phone"
              rules={[
                {
                  message: "Please input your English phone!",
                },
              ]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* google map  */}
          <div className="col-sm-12 col-md-12">
            <Form.Item
              label={translate("FORM.GOOGLEMAPURL")}
              name="map_url"
              rules={[{ type: "string", min: 6 }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* nfc url  */}
          <div className="col-sm-12 col-md-12">
            <Form.Item
              label={translate("FORM.NFCURL")}
              name="nfc_url"
              rules={[{ required: true, type: "string", min: 6 }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* employee */}
          <div className="col-sm-12 col-md-12 col-lg-7">
            <Form.Item
              label={translate("FORM.EMPLOYEE")}
              name="employee"
              rules={[
                { required: true, message: "Please input your employee!" },
              ]}
            >
              <Select
                showSearch
                style={{ height: 40 }}
                placeholder="Select a employee"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Select.Option value="محمود مصطفي"> محمود مصطفي </Select.Option>
                <Select.Option value="أحمد جودة"> أحمد جودة </Select.Option>
                <Select.Option value="سامح أمين"> سامح أمين</Select.Option>
                <Select.Option value="محمد نصرالله">
                  {" "}
                  محمد نصرالله
                </Select.Option>
                <Select.Option value="أحمد راتب"> أحمد راتب </Select.Option>
              </Select>
            </Form.Item>
          </div>
          {/* date */}
          <div className="col-sm-12 col-md-6 col-lg-5">
            <Form.Item name="createdDate" label="card date">
              <DatePicker
                style={{ width: "100%", height: 40 }}
                format={"DD/MM/YYYY"}
                defaultValue={dayjs()}
              />
            </Form.Item>
          </div>
          {/*count */}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item label={translate("FORM.COUNT")}>
              <Form.Item name="count1" noStyle>
                <InputNumber
                  style={{ width: "100%", height: 40 }}
                  min={1}
                  max={100}
                />
              </Form.Item>
            </Form.Item>
          </div>
          {/* price  */}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item label={translate("FORM.PRICE")}>
              <Form.Item name="price" noStyle>
                <InputNumber
                  style={{ width: "100%", height: 40 }}
                  min={0}
                  max={500}
                />
              </Form.Item>
            </Form.Item>
          </div>
          {/* payment type */}
          <div className="col-sm-12 col-md-12 col-lg-4">
            <Form.Item
              label={translate("FORM.PAYMENTTYPE")}
              name="paymentType"
              rules={[
                { required: true, message: "Please input your payment type!" },
              ]}
            >
              <Select
                showSearch
                style={{ height: 40 }}
                placeholder="Select a payment type"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Select.Option value="cash"> {translate("PAYMENTTYPE.CASH")} </Select.Option>
                <Select.Option value="card"> {translate("PAYMENTTYPE.CARD")} </Select.Option>
                <Select.Option value="transfer"> {translate("PAYMENTTYPE.TRANSFER")} </Select.Option>
              </Select>
            </Form.Item>
          </div>
        </div>

        <Form.Item label={null}>
          <Button
            className="d-block w-25 m-auto mt-3 fs-3"
            style={{ height: 60, backgroundColor: "#00b894" }}
            type="primary"
            htmlType="submit"
          >
            {translate("BUTTONS.SAVE")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditGcardForm;
